<template>
  <div class="copy-input">
    <input
      ref="copyInput"
      :value="value"
      type="text"
      readonly
      class="copy-input__field"
    >
    <button
      class="copy-input__button"
      aria-label="Copiar texto"
      @click="copyToClipboard"
    >
      <svg-loader
        src="/static/images/site/icon-copy.svg"
        class="copy-input__icon"
      />
    </button>
  </div>
</template>

<script>
export default {
  name: "CopyInput",
  props: {
    value: {
      type: String,
      required: true
    }
  },
  methods: {
    copyToClipboard() {
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(this.value);
      } else {
        const input = this.$refs.copyInput;
        input.select();
        document.execCommand("copy");
      }
    }
  }
};
</script>

<style lang="scss">
.copy-input {
  display: flex;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 5px;
  overflow: hidden;
  width: 100%;
  height: 40px;

  &__field {
    flex: 1;
    border: none;
    padding: 8px 12px;
    font-size: 14px;
    color: #999999;
    background: #fff;
    outline: none;
  }

  &__button {
    background: #7F1A54;
    border: none;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    border-radius: 0;
    cursor: pointer;
    transition: background 0.3s;

    &:hover {
      background: #6a1345;
    }
  }

  &__icon {
    width: 20px;
    height: 20px;
    min-width: 20px;
    min-height: 20px;
  }
}
</style>
